import type { ContractClause } from "@closer/shared";

/**
 * SALT-OKUNUR MADDE LİSTESİ — paylaşılan sözleşme önizlemesi ve haricî misafir görünümü
 * (CLOS-1127 K2) aynı çiziciyi kullanır: önizleme METİNDİR, künye değil. Sahip tarafının
 * zengin blok editörü değil; hiçbir eylem, işaret ya da düzenleme yüzeyi taşımaz.
 */
export function ClauseReadOnlyList({
  maddeler,
  testId,
}: {
  maddeler: readonly ContractClause[];
  testId: string;
}) {
  return (
    <ol className="flex flex-col gap-2" data-testid={testId}>
      {maddeler.map((madde) => (
        <li key={madde.id} className="rounded-md bg-surface p-2">
          <p className="text-xs font-medium text-fg-strong">
            {madde.title.length > 0 ? madde.title : "Başlıksız madde"}
          </p>
          {madde.blocks.map((blok, i) => (
            <p key={i} className="mt-1 text-xs whitespace-pre-wrap text-fg-muted">
              {blok.text}
            </p>
          ))}
        </li>
      ))}
    </ol>
  );
}
